import ReactComponent from '../../app/ReactComponent'
import {Button, Col, Form, Input, Result, Row, Spin} from 'antd'
import TextArea from 'antd/es/input/TextArea'
import {$t, _$t} from '../../app'
import dayjs from 'dayjs'

export default class ContactSection extends ReactComponent {
  state = {
    formIsForming: false,
    complete: false,
    t: {}
  }

  async componentDidMount() {

    void this.updateState({
      t: {
        your_name_placeholder: await _$t('your_name_placeholder'),
        phone_placeholder: await _$t('phone_placeholder'),
        email_placeholder: await _$t('email_placeholder'),
        message_placeholder: await _$t('message_placeholder')
      }
    })
  }

  t(key) {
    return this.state.t.hasOwnProperty(key) ? this.state.t[key] : ''
  }

  async handleContactFormSubmit(data) {
    await this.updateState({formIsForming: true})

    try {
      const res = await this.$app.$directus('contact_form', {
        data: {
          name: data.name,
          phone: data.phone,
          email: data.email,
          message: data.message
        }
      })

      void this.updateState({
        formIsForming: false,
        complete: true
      })

    } catch (e) {

      void this.updateState({
        formIsForming: false,
      })

      this.handleError(e)

    }
  }

  render() {
    return (
      <section className="container centered va-margin contact-form">

        {this.state.complete ?

          <Result
            status="success"
            title={<$t _="contact_form_complete_title"/>}
            subTitle={<$t _="contact_form_complete_subtitle"/>}
            extra={null}
          />

          :

          <Form
            name="contact-form"
            layout="vertical"
            onFinish={(data) => {
              void this.handleContactFormSubmit(data)
            }}

          >
            <Row gutter={48}>

              <Col span={24}>
                <h3 className="ta-center text-grad h1">
                  <$t _="contact_us"/>
                </h3>
                <p className="ta-center h6 text-grad-grey mb-4">
                  <$t _="contact_us_subtitle"/>
                </p>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="name"
                  label={<$t _="your_name"/>}
                  rules={[{required: true, message: <$t _="name_required"/>}]}
                >
                  <Input size="large" placeholder={this.t('your_name_placeholder')}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="email"
                  label={<$t _="your_mail"/>}
                  rules={[{required: true, message: <$t _="email_required"/>}]}
                >
                  <Input size="large" placeholder={this.t('email_placeholder')}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="phone"
                  label={<$t _="your_phone"/>}
                >
                  <Input size="large" placeholder={this.t('phone_placeholder')}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="message"
                  label={<$t _="message"/>}
                  rules={[{required: true, message: <$t _="message_required"/>}]}
                >
                  <Input.TextArea autoSize={{minRows: 5, maxRows: 12}} placeholder={this.t('message_placeholder')}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={24} className="ta-right">
                <Button
                  type="primary"
                  size="large"
                  icon={<Spin spinning={this.state.formIsForming}/> }
                  htmlType="submit">
                  <$t _="submit"/>
                </Button>
              </Col>

            </Row>
          </Form>
        }
      </section>
    )
  }
}